export default {
    routes_templates_modal_cloneRoute_title: "Clone Route",
    routes_templates_modal_cloneRoute_label: "Assign a name to the Route to be cloned",
    routes_templates_modal_cloneRoute_name: "Name",
    routes_templates_modal_cloneRoute_sucess: "Cloned route sucessfull"
}